import { Realm, REALMS } from "../constants";
import { SafeStorage } from "./SafeStorage";

export interface RecentSearchEntry {
  customerId: string;
  realm: Realm;
}

const STORAGE_KEY = "abrc.recentSearches";
const MAX_ENTRIES = 8;

const isValidEntry = (value: unknown): value is RecentSearchEntry => {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const entry = value as Record<string, unknown>;
  return typeof entry.customerId === "string" && entry.customerId.length > 0 && REALMS.includes(entry.realm as Realm);
};

export class RecentSearches {
  static list(): RecentSearchEntry[] {
    const raw = SafeStorage.get(STORAGE_KEY);
    if (!raw) {
      return [];
    }
    try {
      const parsed: unknown = JSON.parse(raw);
      if (!Array.isArray(parsed)) {
        return [];
      }
      return parsed.filter(isValidEntry).slice(0, MAX_ENTRIES);
    } catch {
      return [];
    }
  }

  static add(entry: RecentSearchEntry): RecentSearchEntry[] {
    const others = this.list().filter((e) => !(e.customerId === entry.customerId && e.realm === entry.realm));
    const next = [entry, ...others].slice(0, MAX_ENTRIES);
    SafeStorage.set(STORAGE_KEY, JSON.stringify(next));
    return next;
  }

  static clear(): RecentSearchEntry[] {
    SafeStorage.remove(STORAGE_KEY);
    return [];
  }
}
